import React from 'react';
import { observer } from 'mobx-react';
import { Button } from 'core/components';
import $auth from 'app/stores/$auth';

import QueryModel from 'app/stores/ude/QueryModel';
import SudoTaggedText from 'app/components/SudoTaggedText';

interface Props {
  queryModel: QueryModel;
}

function UdeDebugButton({ queryModel }: Props) {
  if (!$auth.isSudoer) {
    return null;
  }

  return (
    <>
      <Button
        icon="diagnosis"
        text={<SudoTaggedText>Debug</SudoTaggedText>}
        onClick={() => queryModel.handleShowDebugDialog()}
      />
    </>
  );
}

export default observer(UdeDebugButton);
